import React, { ComponentProps } from 'react';
import { PageLeadDefault } from '../../_lib/components/PageLead';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';

type RolePageLead = {
  roleName: string;
  roleDescription: string;
};

function RolePageLead({ roleName, roleDescription }: RolePageLead) {
  return <PageLeadDefault title={roleName} leadText={roleDescription} />;
}

export const RolePageLeadBlock = asBlock(RolePageLead, BlockType.rolepagelead);
export type RolePageLeadBlock = ComponentProps<typeof RolePageLeadBlock>;
